import axios from 'axios';
import { apiUrl } from '../config/env';

class Services{

  /**
   *
   * Eshop services
   *
   */

  async getProducts() {

    const response = await fetch(apiUrl('/product'));

    const data = await response.json();

    return data;

  }

  async getProductsType(type: string) {

    let filter: string = ""

    if(type == 'private'){
        filter = '?filter={"filter": "1"}';
    }
    if(type == 'public'){
        filter = '?filter={"filter": "0"}';
    }

    const response = await fetch(apiUrl('/product') + filter);

    const data = await response.json();

    return data;

  }

  async getProduct(id: any) {

    const response = await fetch(apiUrl(`/product/${id}`));
    const data = await response.json();

    return data;

  }

  async getCart(id: any) {

    const response = await axios.get(apiUrl(`/cart/${id}`),{});
    const data = await response;

    console.log('Cart return');
    console.log(data.data);

    return data.data;

  }

  async editCartItem(id: any,change: any) {

    axios.put(apiUrl(`/order-item/${id}`),
      change
    ,
    {
      headers: { 'x-access-token': 'token' }
    }
    ).then((response) => {

      console.log(response);

      return response;

    })
    .catch((error) => {

      return error;

    });

  }

  async dropCartItem(id: any) {

    axios.delete(apiUrl(`/cart/${id}`))
    .then((response) => {

      console.log(response);

      return response;

    })
    .catch((error) => {

      return error;

    });

  }

  async getShipmentList() {

    const response = await fetch(apiUrl('/order-shipment'));
    const data = await response.json();

    console.log(data)

    return data;

  }

  async getPaymentList() {

    const response = await fetch(apiUrl('/order-payment'));
    const data = await response.json();

    console.log(data)

    return data;

  }

  async getProductPlaces() {

    const response = await fetch(apiUrl('/product-place'));
    const data = await response.json();

    return data;

  }

  async addToCart(orderId: any, productId: string, idProductPlace: string, count: string) {

    axios.post(apiUrl('/cart'),
    {
      orderId: orderId,
      idProduct: productId.toString(),
      productPlace: idProductPlace,
      count: count
    },
    {
      headers: { 'x-access-token': 'token' }
    }
    )

      .then((response) => {

        localStorage.setItem('orderId',response.data.orderId);
        localStorage.setItem('orderIdInt',response.data.id);

        console.log(response);

        return response;

      })
      .catch((error) => {

        return error;

      });

  }

  async updateCart(cart: any) {

    const response = axios.put(apiUrl('/cart'),
      cart,
    {
      headers: { 'x-access-token': 'token' }
    }
    )

    const data = await response;

    return data;

  }

  async updateCartItem(cart: any, item: any, data: any) {

    const response = axios.put(apiUrl(`/cart/${cart}/item/${item}`),
      data,
    {
      headers: { 'x-access-token': 'token' }
    }
    )

    const output = await response;

    return output;

  }

  async createOrder(id: any) {

    let createUrl = apiUrl(`/orders/${id}/create`)

    const response = await axios.put(createUrl,
    {

    },
    {
      headers: { }
    }
    )

    const data = await response;

    return data;

  }

  async addVoucher(orderId: any, voucher: any) {

    try {

      const response = await axios.post(apiUrl(`/orders/${orderId}/add-voucher`),
      {
        label: voucher,
      },
      {
        headers: { 'x-access-token': 'token' }
      })

      const data = await response;

      return data.data;

    } catch (err) {

        return "error"

    }

  }

  async removeVoucher(orderId: any) {

    const response = await axios.delete(apiUrl(`/orders/${orderId}/delete-voucher`),
    {
      headers: { 'x-access-token': 'token' }
    })

    const data = await response;

    return data.data;

  }

  /**
   *
   * Reservations services
   *
   */

   async getFreeTerms() {

     const response = await fetch(apiUrl('/product/terms?active=1'));
     const data = await response.json();

     return data;

   }

   async getTerm(id: any) {

     const response = await fetch(apiUrl(`/product/terms/${id}`));
     const data = await response.json();

     return data;

   }

   async getFreeTermsType(id: any) {

     const response = await fetch(apiUrl(`/product/${id}/terms`));
     const data = await response.json();

     return data;

   }

   async createReservation(reservant: any, idTerm: any) {

     const response = await axios.post(apiUrl('/order-reservation'),
     {
       firstname: reservant.firstname,
       lastname: reservant.lastname,
       email: reservant.email,
       phone: reservant.phone,
       idTerm: Number(idTerm),
     },
     {
       headers: { 'x-access-token': 'token' }
     })

     const data = await response;

     return data.data;

   }

   async updateReservant(reservant: any, reservationId: any) {

     const response = await axios.put(apiUrl(`/order-reservation/${reservationId}`),
     {
       firstname: reservant.firstname,
       lastname: reservant.lastname,
       email: reservant.email,
       phone: reservant.phone,
     },
     {
       headers: { 'x-access-token': 'token' }
     }
     )

     const data = await response;

     return data.data;

   }

   async updateReservationItem(orderItem: any, itemData: any) {

     const response = await axios.put(apiUrl(`/order-item/${orderItem}`),

     itemData

     ,
     {
       headers: { 'x-access-token': 'token' }
     }
     )

     const data = await response;

     console.log(data);

   }

   async checkFlyNumber(flyNumber: any, idTerm: any) {

     const response = await axios.post(apiUrl('/order-reservation/check-fly-number'),
       {
         flyNumber: flyNumber,
         idTerm: Number(idTerm)
       },
       {
         headers: { 'x-access-token': 'token' }
       }
     ).catch((error) => {

       return error

     });

     const data = await response;

     return data.data



   }

   async addReservation(flyNumber: any, idTerm: any, reservationId: any) {

     const response = await axios.put(apiUrl(`/order-reservation/${reservationId}`),
     {
       idTerm: Number(idTerm),
       flyNumber: flyNumber
     },
     {
       headers: { 'x-access-token': 'token' }
     }
     )

     const data = await response;

     return data.data;

   }


}

export default Services;
